import React, { useRef, useEffect, useCallback, useState} from 'react';
import PianoRollComponent from "components/pianoroll/PianoRollComponent.js";
import {
    setArrangementBottomHeight,
    setShowEditorBottom} from 'actions/index.js';
import {useConsumeWheel} from "components/hooks/useConsumeWheel.js"
import {EFFECTS, PIANO_ROLL} from 'constants/editor-bottom-modes.js';
import EffectsView from "components/effects/EffectsView.js";
import TrackComponent from "components/v2/TrackComponent.js";
import {connect} from 'react-redux';
import './bottom.scss';

const EditorBottom = ({scrollRef, editorBottomRef, leftSidebarWidth, bottomHeight, track, show, setShow, showSidebar, setBottomHeight}) => { 
    const [resizing, setResizing] = useState(false);
    useConsumeWheel(editorBottomRef);

    useEffect(() => {
        window.addEventListener("mousemove", onMouseMove);
        window.addEventListener("mouseup", onMouseUp);
        return () => {
            window.removeEventListener("mousemove", onMouseMove);
            window.removeEventListener("mouseup", onMouseUp);
        };
    }, [resizing]);

    const onMouseUp = useCallback(e => {
        if (resizing) {
            setResizing(false);
        }
    }, [resizing, setResizing]);

    const onMouseMove = useCallback(e => {
        if (!resizing) {
            return;
        }
        let height = Math.min(window.innerHeight - 46, window.innerHeight - e.pageY);
        setBottomHeight(height);
    }, [resizing]);

    let sequencerEngine = track && track.sequencerEngine;
    let className = "editor-bottom";
    if (show) {
        className += " show";
    }
    if (!showSidebar) {
        className += " full-width";
    }

    let inner = '';
    if (show && track) {
        if (show === EFFECTS) {
            inner = (
                <EffectsView
                  sequencerEngine={sequencerEngine}
                  onEffectsChange={() => []}
                  installation={true}
                  store={sequencerEngine.store}
                  tracks={sequencerEngine.tracks}
                  onParameterChanged={(p) => []}
                  sends={sequencerEngine.sends}
                  track={track} scrollContainer={editorBottomRef}/>);
        } else {
            inner = (<PianoRollComponent
                       hideSidebar={true}
                       parentClassName={className}
                       scale={0.5}
                       installation={true}
                       sequencerEngine={sequencerEngine}
                       hideToolbar={true}
                       track={track}
                     />);
        }
    } 
    
    let style = {
        width: window.innerWidth - leftSidebarWidth - 240,
        maxWidth: window.innerWidth - 240 - leftSidebarWidth,
    };

    if (show === PIANO_ROLL) {
        style.height = bottomHeight;
        style.maxHeight = bottomHeight;
        className += " piano-roll-mode";
    } else {
        className += " effects-mode";
    }
    style.left = leftSidebarWidth;
    return (
        <div style={style} ref={editorBottomRef} className={className}>
          <div onMouseDown={() => setResizing(true)} className="editor-bottom-resizer"/>
          <div
            onClick={() => setShow(show ? undefined : EFFECTS)}
            className="collapse-container">
            <div className={show ? "arrow-right" : "arrow-up"}/>
          </div>
          {inner}
       </div>);
}

const mapStateToProps = (state, props) => {
  return {
      showSidebar: state.spatial.sidebarsShowing,
      track: props.sequencerEngine.getSelectedTrack(),
      show: state.spatial.showEditorBottom,
      bottomHeight: state.arrangement.bottomHeight,
      leftSidebarWidth: state.spatial.leftSidebarWidth
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
      setBottomHeight: (x) => dispatch(setArrangementBottomHeight(x)),
      setShow: (x) => dispatch(setShowEditorBottom(x))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EditorBottom);
